// Fuente unica de verdad para la URL del backend.
//
// Desarrollo local: crea `.env.local` (ignorado por git) en la raiz del
// frontend con: REACT_APP_API_URL=http://localhost:8000
// Reinicia `npm start` despues de crearlo/editarlo (CRA solo lee las env vars al arrancar).
//
// Si la variable no esta definida (ej. el build de produccion en Render,
// que no la configura), cae automaticamente al backend en su dominio propio.
export const API_URL =
  process.env.REACT_APP_API_URL || 'https://api.kredilibranza.com';
